import React from 'react'

import { Container, Row, Col } from 'react-bootstrap';
import { useGetMajhoolProductsQuery } from '../../slices/productsApiSlice';
import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { FaAngleLeft, FaAngleRight } from "react-icons/fa";
import Skeleton from 'react-loading-skeleton';

import Meta from '../../components/Meta';
import ShoppingProduct from '../../components/ShoppingProduct';

const SITE = 'https://tamratdates.com';

const FAQ_AR = [
  { q: 'لماذا يُسمّى المجدول ملك التمور؟', a: 'لحجمه الكبير وقوامه الطري اللحمي ونكهته الكراميلية الغنية، فهو من أفخم أنواع التمور وأكثرها رواجاً عالمياً.' },
  { q: 'ما طعم التمر المجدول؟', a: 'حلاوته غنية بنكهة قريبة من الكراميل، وقوامه طري ولحمي مميّز.' },
  { q: 'هل المجدول مناسب للحشو؟', a: 'نعم، حجمه الكبير يجعله مثالياً للحشو بالمكسرات أو تغطيته بالشوكولاتة وللتقديم الفاخر.' },
  { q: 'كيف أحفظ التمر المجدول؟', a: 'احفظه في مكان بارد وجاف، أو في الثلاجة للحفاظ على طراوته لفترة أطول.' },
];
const FAQ_EN = [
  { q: 'Why is Majhool called the king of dates?', a: 'For its large size, soft fleshy texture and rich caramel-like flavour — it is one of the most premium and globally popular dates.' },
  { q: 'What do Majhool dates taste like?', a: 'A rich, caramel-like sweetness with a soft, fleshy texture.' },
  { q: 'Are Majhool dates good for stuffing?', a: 'Yes — their large size makes them ideal for stuffing with nuts or coating in chocolate, and for premium presentation.' },
  { q: 'How do I store Majhool dates?', a: 'Keep them in a cool, dry place, or refrigerate to preserve their softness for longer.' },
];

function MajhoolDates() {

  const { t , i18n } = useTranslation();
  const en = i18n.language === 'en';

    const { data, isLoading, error } = useGetMajhoolProductsQuery();

  const url = `${SITE}/majhool-date`;
  const faq = en ? FAQ_EN : FAQ_AR;
  const schema = [
    {
      '@context': 'https://schema.org',
      '@type': 'BreadcrumbList',
      itemListElement: [
        { '@type': 'ListItem', position: 1, name: en ? 'Home' : 'الرئيسية', item: `${SITE}/` },
        { '@type': 'ListItem', position: 2, name: en ? 'Majhool Dates' : 'تمر المجدول', item: url },
      ],
    },
    {
      '@context': 'https://schema.org',
      '@type': 'FAQPage',
      mainEntity: faq.map((f) => ({
        '@type': 'Question',
        name: f.q,
        acceptedAnswer: { '@type': 'Answer', text: f.a },
      })),
    },
  ];

    if(isLoading) {
      return(
      <div>
   <div className='d-flex text-center align-items-center p-5 pb-0 gap-1 ml-5'>
   <Skeleton width={150} />
   </div>
      <h1 className="title">
         <Skeleton width={150} />
      </h1>
        <Row className="py-5">
        <Col sm={4} className="mb-2"><Skeleton height={250} width={350} /></Col>
        <Col sm={4} className="mb-2"><Skeleton height={250} width={350} /></Col>
        <Col sm={4} className="mb-2"><Skeleton height={250} width={350} /></Col>
        <Col sm={4} className="mb-2"><Skeleton height={250} width={350} /></Col>
        <Col sm={4} className="mb-2"><Skeleton height={250} width={350} /></Col>
        <Col sm={4} className="mb-2"><Skeleton height={250} width={350} /></Col>
        </Row>
    </div>
      )
    }

  return (
    <div>
      {en ? (
        <>
          <Meta
            title={'Majhool (Medjool) Dates — Premium King of Dates | Tamrat'}
            description={'Buy premium Majhool (Medjool) dates online from Tamrat — large, soft, caramel-rich dates, the "king of dates". Fast delivery across Saudi Arabia, free over 250 SAR.'}
            url={url}
            type={'website'}
            schema={schema}
          />
          <div className='d-flex text-center align-items-center p-5 pb-0 gap-1 ml-5'>
            <Link to={'/'}><span className='text-decoration-underline'>Home</span></Link>
            <FaAngleRight />
            <span style={{color:'#7C9D64'}}>Majhool Date</span>
          </div>
        </>
      ) : (
        <>
          <Meta
            title={'تمر مجدول فاخر — ملك التمور | تمرات'}
            description={'اشترِ التمر المجدول الفاخر من تمرات: كبير الحجم، طري لحمي، ونكهة كراميلية غنية — ملك التمور. توصيل سريع لكل مناطق السعودية وشحن مجاني للطلبات فوق ٢٥٠ ر.س.'}
            url={url}
            type={'website'}
            schema={schema}
          />
          <div className='d-flex text-center align-items-center p-5 pb-0 gap-1 ml-5'>
            <Link to={'/'}><span className='text-decoration-underline'>الرئيسية</span></Link>
            <FaAngleLeft />
            <span style={{color:'#7C9D64'}}>تمر المجدول</span>
          </div>
        </>
      )}

      <h1 className="title">{t('majhoolTitle')}</h1>
      <Container>
        <Row className="py-5">
        { error ? (
        <div>{error?.data.message || error.error}</div>
      ) : (
        data.products.map((product) => (
          <Col sm={4} key={product.id} className='mb-4 p-4'>
         <ShoppingProduct product={product} />
        </Col>
         ))
             )}
        </Row>
      </Container>

      <Container className="pb-5" dir={en ? 'ltr' : 'rtl'} style={{ maxWidth: 900, lineHeight: 1.9, color: '#3d3d3d' }}>
        {en ? (
          <div>
            <h2 style={{ color: '#7C9D64' }}>What is Majhool?</h2>
            <p>Majhool (Medjool) is one of the most premium dates in the world, often called the <strong>"king of dates"</strong>. It is large, soft and fleshy, with a rich, caramel-like flavour. It's an indulgent everyday treat and a standout choice for gifting — served on its own, stuffed with nuts, or coated in chocolate.</p>
            <h2 style={{ color: '#7C9D64' }}>How to enjoy Majhool dates</h2>
            <ul>
              <li>As a luxurious bite on its own.</li>
              <li>Stuffed with nuts or coated in chocolate.</li>
              <li>As a premium gift.</li>
              <li>With Arabic coffee or at breakfast.</li>
            </ul>
            <h2 style={{ color: '#7C9D64' }}>Nutrition</h2>
            <p>Majhool dates are a natural source of energy, fibre and potassium. <em>Values are approximate and vary by size and ripeness; for any specific diet, consult a specialist.</em></p>
            <h2 style={{ color: '#7C9D64' }}>Who it's for</h2>
            <p>For lovers of large, soft, caramel-rich dates, for premium gifting, and as an indulgent natural treat.</p>
            <h2 style={{ color: '#7C9D64' }}>Frequently asked questions</h2>
            {FAQ_EN.map((f, i) => (<div key={i}><h3 style={{ fontSize: 18 }}>{f.q}</h3><p>{f.a}</p></div>))}
          </div>
        ) : (
          <div>
            <h2 style={{ color: '#7C9D64' }}>ما هو التمر المجدول؟</h2>
            <p>المجدول من أفخم أنواع التمور في العالم، ويُلقَّب بـ<strong>«ملك التمور»</strong>. يتميّز بحجمه الكبير وقوامه الطري اللحمي ونكهته الكراميلية الغنية. خيار مثالي للتدليل اليومي وللإهداء الفاخر، ويُقدَّم بمفرده أو محشواً بالمكسرات أو مغطى بالشوكولاتة.</p>
            <h2 style={{ color: '#7C9D64' }}>كيف تستمتع بالتمر المجدول؟</h2>
            <ul>
              <li>قضمة فاخرة بمفرده.</li>
              <li>محشو بالمكسرات أو مغطى بالشوكولاتة.</li>
              <li>هدية مميّزة وراقية.</li>
              <li>مع القهوة العربية أو في الإفطار.</li>
            </ul>
            <h2 style={{ color: '#7C9D64' }}>القيمة الغذائية</h2>
            <p>التمر المجدول مصدر طبيعي للطاقة والألياف والبوتاسيوم. <em>القيم تقريبية وتختلف حسب الحجم ودرجة النضج؛ ولأي نظام غذائي خاص يُنصح باستشارة مختص.</em></p>
            <h2 style={{ color: '#7C9D64' }}>لمن يناسب؟</h2>
            <p>لمحبّي التمر الكبير الطري الكراميلي، وللإهداء الفاخر، وكوجبة خفيفة طبيعية فاخرة.</p>
            <h2 style={{ color: '#7C9D64' }}>الأسئلة الشائعة</h2>
            {FAQ_AR.map((f, i) => (<div key={i}><h3 style={{ fontSize: 18 }}>{f.q}</h3><p>{f.a}</p></div>))}
          </div>
        )}
      </Container>
    </div>
  )
}

export default MajhoolDates
